const yearAndQuarterRegExp = /(\d{4})\s?Q([1234])/;

/**
 * @param input - a string like '2021 Q3' or '2021Q3'. The space between the year and quarter is
 * optional.
 * @returns a {@link YearAndQuarter} object if one can be parsed from the string, or null if not.
 */
export const parseYearAndQuarter = (input: string): Maybe<YearAndQuarter> => {
    const match = input.match(yearAndQuarterRegExp);

    if (match !== null) {
        return {
            year: parseInt(match[1], 10),
            quarter: parseInt(match[2], 10),
        };
    }

    return null;
};
